// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.definition-tooltip {
  position: relative;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  flex-shrink: 0;
  z-index: 1;
}
.definition-tooltip__example {
  margin: 5px 0 1px;
  font-size: 12px;
  line-height: 1.45;
  color: var(--tooltip-muted-color, #6b7280);
}
.definition-tooltip__example strong {
  font-weight: 600;
}
.definition-tooltip__formula-line {
  font-size: 11px;
  line-height: 1.35;
  margin-top: 6px;
  font-weight: 500;
  color: #6a7282;
}
.definition-tooltip__formula-line:first-of-type {
  margin-top: 8px;
}
.definition-tooltip__bullets {
  margin: 0 0 0px;
  padding-inline-start: 18px;
  list-style: disc;
}
.definition-tooltip__bullet {
  font-size: 12px;
  line-height: 1.45;
  color: var(--tooltip-muted-color, #6b7280);
  margin-bottom: 0px;
}
.definition-tooltip__bullet:last-child {
  margin-bottom: 0;
}
.definition-tooltip .definition-tooltip__bullet {
  padding-left: 0px;
}
.definition-tooltip .example-txt-color {
  color: rgb(33, 33, 33);
  font-size: 14px;
}
.definition-tooltip__databasis {
  margin: 12px 0 0;
  padding-top: 5px;
  border-top: 1px solid var(--tooltip-border-color, #e5e7eb);
  font-size: 12px;
  font-style: italic;
  color: var(--tooltip-muted-color, #6b7280);
}

.definition-tooltip__popover {
  overflow: visible;
  box-sizing: border-box;
}

.definition-tooltip__text,
.definition-tooltip__formula-title,
.definition-tooltip__formula-line,
.definition-tooltip__example,
.definition-tooltip__bullets,
.definition-tooltip__bullet,
.definition-tooltip__databasis,
.definition-tooltip__note {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  overflow-wrap: break-word;
  word-break: break-word;
}

.definition-tooltip__bullets {
  box-sizing: border-box;
  width: 100%;
}

.definition-tooltip--align-end .definition-tooltip__popover {
  left: auto;
  right: 0;
}

.definition-tooltip__trigger {
  width: 16px;
  height: 16px;
  min-width: 16px;
  border: 1px solid #d1dae8;
  border-radius: 50%;
  background: #f4f7fc;
  color: #7f93ad;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 10px;
  line-height: 1;
  font-weight: 700;
  cursor: default;
  transform: translateY(1px);
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.definition-tooltip__trigger:hover,
.definition-tooltip__trigger:focus-visible {
  background: #eef4fb;
  border-color: #b8c8de;
  color: #5c6f88;
  outline: none;
}

.definition-tooltip__popover {
  position: fixed;
  top: 0;
  left: 0;
  width: 380px;
  max-width: min(380px, 100vw - 16px);
  max-height: calc(100vh - 16px);
  border-radius: 12px;
  border: 1px solid #d9e3f2;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(14, 30, 62, 0.16);
  padding: 14px;
  z-index: 5000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-4px);
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;
  pointer-events: none;
  overflow-y: auto;
  overflow-wrap: anywhere;
  white-space: normal;
  font-family: "opensans", sans-serif;
  font-style: normal;
  font-variant: normal;
  font-weight: 400;
  letter-spacing: normal;
  line-height: normal;
  text-align: start;
  text-transform: none;
}

@media (max-width: 900px) {
  .definition-tooltip__popover {
    left: 0;
    right: auto;
    width: min(320px, 100vw - 40px);
  }
  .definition-tooltip--align-end .definition-tooltip__popover {
    right: 0;
    left: auto;
  }
}
.definition-tooltip__popover--open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.definition-tooltip__text {
  margin: 0 0 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.45;
  color: #6a7282;
  text-align: start;
}

.definition-tooltip__text:last-child {
  margin-bottom: 0;
}

.definition-tooltip__formula-box {
  border-radius: 10px;
  background: #e8f0fb;
  border-inline-start: 4px solid #1f5da8;
  padding: 10px 12px 12px;
}

.definition-tooltip__formula-title {
  margin: 0 0 4px;
  font-size: 13px;
  line-height: 1;
  color: #6a7282;
  font-weight: 700;
}

.definition-tooltip__formula {
  margin: 0;
  font-size: 11px;
  line-height: 1.35;
  color: #6a7282;
  font-weight: 500;
}

.definition-tooltip__note {
  margin: 10px 0 0;
  font-size: 10px;
  line-height: 1.45;
  color: #98a2b3;
  font-weight: 400;
}

@media (prefers-reduced-motion: reduce) {
  .definition-tooltip__popover,
  .definition-tooltip__trigger {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/DefinitionTooltip/DefinitionTooltip.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;AADF;AAIE;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,0CAAA;AAFF;AAIE;EACE,gBAAA;AAFJ;AAMA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAJF;AAME;EACE,eAAA;AAJJ;AAQA;EACE,eAAA;EACA,0BAAA;EACA,gBAAA;AANF;AASA;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,kBAAA;AAPF;AASE;EACE,gBAAA;AAPJ;AAWA;EACE,iBAAA;AATF;AAYA;EACE,sBAAA;EACA,eAAA;AAVF;AAYA;EACE,gBAAA;EACA,gBAAA;EACA,0DAAA;EACA,eAAA;EACA,kBAAA;EACA,0CAAA;AAVF;;AAcA;EACE,iBAAA;EACA,sBAAA;AAXF;;AAcA;;;;;;;;EAQE,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,sBAAA;AAXF;;AAcA;EACE,sBAAA;EACA,WAAA;AAXF;;AAcA;EACE,UAAA;EACA,QAAA;AAXF;;AAcA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,4EAAA;AAXF;;AAcA;;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;AAXF;;AAcA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,mCAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,aAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,wEAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAXF;;AAcA;EACE;IACE,OAAA;IACA,WAAA;IACA,+BAAA;EAXF;EAcA;IACE,QAAA;IACA,UAAA;EAZF;AACF;AAgBA;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAdF;;AAiBA;EACE,gBAAA;AAdF;;AAiBA;EACE,mBAAA;EACA,mBAAA;EACA,sCAAA;EACA,uBAAA;AAdF;;AAiBA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAdF;;AAiBA;EACE;;IAEE,gBAAA;EAdF;AACF","sourcesContent":["// Global KPI metric definition popover (?) — used across all dashboards.\n\n.definition-tooltip {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n  flex-shrink: 0;\n  z-index: 1;\n  \n  // thi style for the example line in the tooltip, which is bolded and has a margin below it\n  &__example {\n  margin: 5px 0 1px;\n  font-size: 12px;\n  line-height: 1.45;\n  color: var(--tooltip-muted-color, #6b7280);\n\n  strong {\n    font-weight: 600;\n  }\n}\n\n&__formula-line {\n  font-size: 11px;\n  line-height: 1.35;\n  margin-top: 6px;\n  font-weight: 500;\n  color: #6a7282;\n  \n  &:first-of-type {\n    margin-top: 8px; // gap below the title\n  }\n}\n\n&__bullets {\n  margin: 0 0 0px;\n  padding-inline-start: 18px;\n  list-style: disc;\n}\n\n&__bullet {\n  font-size: 12px;\n  line-height: 1.45;\n  color: var(--tooltip-muted-color, #6b7280);\n  margin-bottom: 0px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.definition-tooltip__bullet {\n  padding-left: 0px;\n}\n\n.example-txt-color {\n  color: rgb(33, 33, 33);\n  font-size: 14px;\n}\n&__databasis {\n  margin: 12px 0 0;\n  padding-top: 5px;\n  border-top: 1px solid var(--tooltip-border-color, #e5e7eb);\n  font-size: 12px;\n  font-style: italic;\n  color: var(--tooltip-muted-color, #6b7280);\n}\n}\n\n.definition-tooltip__popover {\n  overflow: visible; // keep this — it's for the popover's own edge vs page, not text\n  box-sizing: border-box;\n}\n\n.definition-tooltip__text,\n.definition-tooltip__formula-title,\n.definition-tooltip__formula-line,\n.definition-tooltip__example,\n.definition-tooltip__bullets,\n.definition-tooltip__bullet,\n.definition-tooltip__databasis,\n.definition-tooltip__note {\n  white-space: normal;      // undo the nowrap from earlier\n  overflow: visible;\n  text-overflow: unset;\n  overflow-wrap: break-word; // wraps long words/URLs instead of overflowing\n  word-break: break-word;\n}\n\n.definition-tooltip__bullets {\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.definition-tooltip--align-end .definition-tooltip__popover {\n  left: auto;\n  right: 0;\n}\n\n.definition-tooltip__trigger {\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  border: 1px solid #d1dae8;\n  border-radius: 50%;\n  background: #f4f7fc;\n  color: #7f93ad;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  font-size: 10px;\n  line-height: 1;\n  font-weight: 700;\n  cursor: default;\n  transform: translateY(1px);\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.definition-tooltip__trigger:hover,\n.definition-tooltip__trigger:focus-visible {\n  background: #eef4fb;\n  border-color: #b8c8de;\n  color: #5c6f88;\n  outline: none;\n}\n\n.definition-tooltip__popover {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 380px;\n  max-width: min(380px, calc(100vw - 16px));\n  max-height: calc(100vh - 16px);\n  border-radius: 12px;\n  border: 1px solid #d9e3f2;\n  background: #ffffff;\n  box-shadow: 0 10px 24px rgba(14, 30, 62, 0.16);\n  padding: 14px;\n  z-index: 5000;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-4px);\n  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;\n  pointer-events: none;\n  overflow-y: auto;\n  overflow-wrap: anywhere;\n  white-space: normal;\n  font-family: \"opensans\", sans-serif;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: 400;\n  letter-spacing: normal;\n  line-height: normal;\n  text-align: start;\n  text-transform: none;\n}\n\n@media (max-width: 900px) {\n  .definition-tooltip__popover {\n    left: 0;\n    right: auto;\n    width: min(320px, calc(100vw - 40px));\n  }\n\n  .definition-tooltip--align-end .definition-tooltip__popover {\n    right: 0;\n    left: auto;\n  }\n}\n\n\n.definition-tooltip__popover--open {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.definition-tooltip__text {\n  margin: 0 0 12px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.45;\n  color: #6a7282;\n  text-align: start;\n}\n\n.definition-tooltip__text:last-child {\n  margin-bottom: 0;\n}\n\n.definition-tooltip__formula-box {\n  border-radius: 10px;\n  background: #e8f0fb;\n  border-inline-start: 4px solid #1f5da8;\n  padding: 10px 12px 12px;\n}\n\n.definition-tooltip__formula-title {\n  margin: 0 0 4px;\n  font-size: 13px;\n  line-height: 1;\n  color: #6a7282;\n  font-weight: 700;\n}\n\n.definition-tooltip__formula {\n  margin: 0;\n  font-size: 11px;\n  line-height: 1.35;\n  color: #6a7282;\n  font-weight: 500;\n}\n\n.definition-tooltip__note {\n  margin: 10px 0 0;\n  font-size: 10px;\n  line-height: 1.45;\n  color: #98a2b3;\n  font-weight: 400;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .definition-tooltip__popover,\n  .definition-tooltip__trigger {\n    transition: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
